export const AUTH_STATES = {
  unauthorized: 0,
  authorized: 1,
  admin: 2
};
